export const CREATE_LICENSE_REQUEST = 'CREATE_LICENSE_REQUEST';
export const CREATE_LICENSE_SUCCESS = 'CREATE_LICENSE_SUCCESS';
export const CREATE_LICENSE_FAILURE = 'CREATE_LICENSE_FAILURE';

export const GET_LICENSES_REQUEST = 'GET_LICENSES_REQUEST';
export const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS';
export const GET_LICENSES_FAILURE = 'GET_LICENSES_FAILURE';

export const DELETE_LICENSE_REQUEST = 'DELETE_LICENSE_REQUEST';
export const DELETE_LICENSE_SUCCESS = 'DELETE_LICENSE_SUCCESS';
export const DELETE_LICENSE_FAILURE = 'DELETE_LICENSE_FAILURE';

export const UPDATE_LICENSE_REQUEST = 'UPDATE_LICENSE_REQUEST';
export const UPDATE_LICENSE_SUCCESS = 'UPDATE_LICENSE_SUCCESS';
export const UPDATE_LICENSE_FAILURE = 'UPDATE_LICENSE_FAILURE';

export const CHANGE_LICENSE_STATUS_REQUEST = 'CHANGE_LICENSE_STATUS_REQUEST';
export const CHANGE_LICENSE_STATUS_SUCCESS = 'CHANGE_LICENSE_STATUS_SUCCESS';
export const CHANGE_LICENSE_STATUS_FAILURE = 'CHANGE_LICENSE_STATUS_FAILURE';

export const GET_LICENSE_USAGE_REQUEST = 'GET_LICENSE_USAGE_REQUEST';
export const GET_LICENSE_USAGE_SUCCESS = 'GET_LICENSE_USAGE_SUCCESS';
export const GET_LICENSE_USAGE_FAILURE = 'GET_LICENSE_USAGE_FAILURE';